(function () {
  if (window.__sizeRecosInit) return;
  window.__sizeRecosInit = true;

  try {
    var marketHandle = (window.__marketHandle || '').toLowerCase();
    var countryIso   = (window.__countryIso || '').toLowerCase();

    var sizeMapping = {
      EU: ['36','37','38','39','40','41','42','43','44','45','46'],
      US: ['6','6.5','7.5','8','7','7.5','8.5','9','10','11','11.5'],
      UK: ['3','4','5','6','6.5','7','8','8.5','9.5','10.5','11']
    };
    var EU = sizeMapping.EU.slice();

    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }
    function getCookie(name) {
      var cname = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(cname) === 0) return c.substring(cname.length);
      }
      return '';
    }
    function defaultRegion() {
      if (marketHandle === 'usa') return 'US';
      if (marketHandle === 'uk')  return 'UK';
      if (marketHandle === 'mundo' && (countryIso === 'ca' || countryIso === 'au')) return 'US';
      return 'EU';
    }
    function setRegion(region, source) {
      currentRegion = region;
      window.__sizeRegion = region;
      setCookie('selectedSizesRegion', region, 30);
      setCookie('selectedSizesRegionSource', source || 'auto', 30);
    }
    function getRegionFromCookies() {
      var r = (getCookie('selectedSizesRegion') || '').toUpperCase();
      var s = (getCookie('selectedSizesRegionSource') || 'auto').toLowerCase();
      return { region: r, source: s };
    }

    var currentRegion;
    (function decideInitialRegion() {
      var saved = getRegionFromCookies();
      if (['US','UK','EU'].indexOf(saved.region) > -1 && saved.source === 'user') {
        currentRegion = saved.region;
        window.__sizeRegion = currentRegion;
      } else {
        setRegion(defaultRegion(), 'auto');
      }
      if (typeof window.highlightActiveButton === 'function') {
        window.highlightActiveButton(window.__sizeRegion);
      }
    })();

    function convertSize(euVal) {
      var v = String(euVal || '').trim();
      var idx = EU.indexOf(v);
      if (idx < 0) return v;
      var map = sizeMapping[currentRegion] || EU;
      return map[idx] || v;
    }

    function elementMatches(el, sel) {
      if (!el || el.nodeType !== 1) return false;
      var p = Element.prototype;
      var f = p.matches || p.msMatchesSelector || p.webkitMatchesSelector;
      return f ? f.call(el, sel) : false;
    }
    function findClosest(el, sel) {
      while (el && el.nodeType === 1) {
        if (elementMatches(el, sel)) return el;
        el = el.parentElement;
      }
      return null;
    }
    function processTrigger(trigger) {
      if (!trigger) return;

      var popId = trigger.getAttribute('aria-controlnew');
      var pop = popId ? document.getElementById(popId) : null;

      if (pop) {
        var btns = pop.querySelectorAll('.Popover__ValueList .Popover__Value[data-size]');
        for (var i = 0; i < btns.length; i++) {
          var eu = btns[i].getAttribute('data-size');
          if (eu) btns[i].textContent = convertSize(eu);
        }
      }

      var label = trigger.querySelector('.ProductForm__SelectedValue');
      if (label) {
        var eu0 = label.getAttribute('data-size');
        if (!eu0 || !eu0.length) {
          var selBtn = pop ? pop.querySelector('.Popover__Value.is-selected[data-size]') : null;
          eu0 = selBtn ? selBtn.getAttribute('data-size') : (label.textContent || '').trim();
          label.setAttribute('data-size', String(eu0 || ''));
        }
        label.textContent = convertSize(eu0);
      }
    }
    function renderCard(card) {
      if (!card) return;
      var triggers = card.querySelectorAll('.ProductForm__Itema--recommendations[aria-controlnew]');
      for (var t = 0; t < triggers.length; t++) processTrigger(triggers[t]);
    }
    function renderAll() {
      var items = document.querySelectorAll('.product-recommendations-container .ProductItem');
      for (var i = 0; i < items.length; i++) renderCard(items[i]);
    }

    var rafId = 0, debounceId = 0;
    function scheduleRenderAll() {
      if (debounceId) return;
      debounceId = setTimeout(function () {
        debounceId = 0;
        if (rafId) return;
        rafId = requestAnimationFrame(function () { rafId = 0; renderAll(); });
      }, 140);
    }

    function startObservers() {
      var container = document.querySelector('.product-recommendations-container');
      if (!container) return;
      var obs = new MutationObserver(scheduleRenderAll);
      obs.observe(container, { childList: true, subtree: true });
    }
    function waitForRecommendationsAndBoot() {
      var selector = '.product-recommendations-container';
      var container = document.querySelector(selector);
      if (container) { startObservers(); renderAll(); setTimeout(renderAll,120); return; }
      var bodyObs = new MutationObserver(function () {
        var c = document.querySelector(selector);
        if (c) { bodyObs.disconnect(); startObservers(); renderAll(); setTimeout(renderAll,120); }
      });
      bodyObs.observe(document.documentElement, { childList: true, subtree: true });
    }

    function wireRegionButtons() {
      var us = document.getElementById('usSizes');
      var uk = document.getElementById('ukSizes');
      var eu = document.getElementById('euSizes');
      function handler(region) {
        return function (ev) {
          if (ev && ev.preventDefault) ev.preventDefault();
          setRegion(region, 'user');
          if (typeof window.highlightActiveButton === 'function') window.highlightActiveButton(region);
          renderAll();
        };
      }
      if (us) us.addEventListener('click', handler('US'));
      if (uk) uk.addEventListener('click', handler('UK'));
      if (eu) eu.addEventListener('click', handler('EU'));
    }

    document.addEventListener('DOMContentLoaded', function () {
      wireRegionButtons();
      renderAll();
      setTimeout(renderAll, 0);
      setTimeout(renderAll, 120);
      waitForRecommendationsAndBoot();

      document.addEventListener('click', function (e) {
        var n = e.target;
        for (var i = 0; i < 10 && n && !elementMatches(n, '.Popover__Value[data-size]'); i++) n = n.parentElement;
        if (!n) return;

        var card = findClosest(n, '.ProductItem');
        if (!card) return;

        setTimeout(function () {
          var triggers = card.querySelectorAll('.ProductForm__Itema--recommendations[aria-controlnew]');
          for (var t = 0; t < triggers.length; t++) {
            var label = triggers[t].querySelector('.ProductForm__SelectedValue');
            if (label) {
              var eu = n.getAttribute('data-size') || '';
              label.setAttribute('data-size', eu);
              label.textContent = convertSize(eu);
            }
          }
          renderCard(card);
        }, 0);
      });
    });
  } catch (err) {
    console.error('[size-recos] fatal:', err);
  }
})();